import ContactTransition from "../DownPage/ContactTransition";


export default function ContactSection() {
    return (
        <section id="home-contact-container">
            <ContactTransition/>
        </section>
    )
}